// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2K5LW{border:1px solid #e2e2e2;background:#fff;border-radius:8px;color:#2d2d2d;transition:box-shadow .3s}._2K5LW:active{-webkit-tap-highlight-color:rgba(0,0,0,0);box-shadow:0 2px 14px rgba(0,0,0,.06)}@media(any-hover:hover){._2K5LW:hover{box-shadow:0 2px 14px rgba(0,0,0,.06)}}._2K5LW.T69qr{box-shadow:0 2px 14px rgba(0,0,0,.06)}.\\+Ja8H{display:flex;align-items:center;justify-content:space-between;padding:16px 12px;cursor:pointer;transition:padding .2s}.T69qr .\\+Ja8H{padding-top:24px;padding-bottom:20px}._08yyU{color:#2d2d2d;font-size:16px;font-weight:600;line-height:24px;transition:color .2s,font-weight .2s}.T69qr ._08yyU{color:#767676;font-weight:400}.ZVTyz{transition:transform .3s}.T69qr .ZVTyz{transform:rotate(180deg)}.Q8tk3{padding:0 0 24px}._2K5LW .XAzXL{padding:0 8px;border:none}@media screen and (min-width:400px){._2K5LW .XAzXL{padding:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandVoiceCard": "_2K5LW",
	"isCardOpened": "T69qr",
	"row": "+Ja8H",
	"title": "_08yyU",
	"button": "ZVTyz",
	"body": "Q8tk3",
	"about": "XAzXL"
};
module.exports = ___CSS_LOADER_EXPORT___;
